import { tableConstantsFactory } from './tableConstantsFactory';
export default tableConstantsFactory('EMPLOYEE');